import React, { useEffect, useState } from 'react';

/** Plugins */
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { CircularProgress, Button } from '@material-ui/core';
import { Add as AddIcon, Edit as EditIcon, ThumbUp, AddBox } from '@material-ui/icons';

/** Components */
import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';
import AdminModal from '../../components/AdminModal/AdminModal';

/** Services */
import {
  getRankings,
  createRanking,
  updateRanking,
  enableRanking,
  approveRanking,
  getRankingBySearch,
  getRankingByOrder,
} from '../../services/ranking';
/** Constants */
import Languages from '../../constants/languages';

/** Actions */
import { showAlert } from '../../store/ducks/alert';

const Ranking = ({ location, match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [pageData, setPageData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [isOrdering, setIsOrdering] = useState(0);
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayPageData();
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const displayPageData = async () => {
    try {
      setIsLoading(true);

      let pageData;
      if (isSearching) {
        const { data } = await getRankingBySearch(searchField.searchItem, searchField.search);
        pageData = data;
      } else if (isOrdering > 0) {
        const { data } = await getRankingByOrder(orderDirections.item, orderDirections.direction);
        pageData = data;
      } else if (!isOrdering && !isSearching && Object.keys(match.params).length === 0) {
        const { data } = await getRankings(page);
        pageData = data;
      }
      if (!pageData) return;

      setPageData(pageData.rows);
      setTotalItems(pageData.count);
      setTotalPages(pageData.pages);
      setPage(pageData.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const headers = ['id', 'name', 'slug', 'approved', 'enabled'];

  const renderLangs = () => {
    let aux = {};
    Languages.map(lang => {
      aux[lang.code] = {
        title: '',
        subtitle: '',
        description: '',
      };
    });
    return aux;
  };

  const modalColumns = [
    { label: 'SQL Query', prop: 'sqlCommand', type: 'text', disabled: isUpdating, required: true },
    { label: 'Limit', prop: 'limit', type: 'number', required: true },
    { label: 'Name', prop: 'name', type: 'text', required: true },
    {
      label: 'Intertionalization',
      prop: 'i18n',
      type: 'i18',
      defaultValue: renderLangs(),
    },
  ];
  const customActions = [
    {
      icon: <ThumbUp />,
      action: item => {
        handleApproveRanking(item.id);
      },
    },
    {
      icon: <EditIcon />,
      action: item => {
        handleOpenUpdate(item);
      },
    },
    {
      icon: <AddBox />,
      action: item => {
        handleEnable(item);
      },
    },
  ];

  const handleApproveRanking = async id => {
    try {
      await approveRanking(id, true);
      dispatch(showAlert('success', 'Success, approved! 🔥'));
      window.location = '/rankings';
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something wrong happened. 😔'));
    }
  };

  const handleCloseModal = () => {
    setFormData({});
    setOpen(false);
  };

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleOpenUpdate = async item => {
    setIsUpdating(true);
    setFormData(item);
    setOpen(true);
  };

  const handleEnable = async item => {
    try {
      if (item.enabled === '⛔️ Não') await enableRanking(item.id, true);
      if (item.enabled === '✅ Sim') await enableRanking(item.id, false);
      dispatch(showAlert('success', 'Success! 🔥'));
      window.location = '/rankings';
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something went wrong. 😔'));
    }
  };

  const handleSubmitForm = async dataForm => {
    try {
      if (!isUpdating) {
        await createRanking(dataForm);
      } else {
        await updateRanking(dataForm.id, dataForm);
      }
      setIsUpdating(false);

      dispatch(showAlert('success', 'Success! 🔥'));
      window.location = '/rankings';
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something went wrong. 😔'));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1> Ranking ({totalItems})</h1>
        <Button onClick={handleOpenModal} variant="contained" className="modal-btn">
          Add Ranking
          <AddIcon />
        </Button>
        {open ? (
          <AdminModal
            columns={modalColumns}
            data={formData}
            modalName={isUpdating ? "Update Ranking" : "Create Ranking"}
            onSubmit={handleSubmitForm}
            onClose={handleCloseModal}
            isUpdating={isUpdating}
          />
        ) : (
          ''
        )}

        <SearchBox selectItems={headers} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} setIsOrdering={setIsOrdering} />
      </div>

      <DataTable
        head={headers}
        body={pageData}
        bodyColumn={headers}
        action={true}
        customActions={customActions}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Ranking;
